import { useState } from 'react';
import { Outlet } from 'react-router-dom';
import LibrarianSidebar from './LibrarianSidebar';
import LibrarianHeader  from './LibrarianHeader';

const style = `
  *, *::before, *::after { box-sizing:border-box; margin:0; padding:0; }
  html, body, #root { height:100%; width:100%; }

  .l-layout-root    { display:flex; height:100vh; width:100vw; overflow:hidden; background:#f0f2f7; position:relative; }
  .l-layout-sidebar {
    flex-shrink:0; width:240px; height:100vh;
    overflow-y:auto; overflow-x:hidden; transition:transform .25s ease;
    scrollbar-width:thin;
    scrollbar-color:#2a2f4e #0f1123;
  }
  .l-layout-sidebar::-webkit-scrollbar { width:4px; }
  .l-layout-sidebar::-webkit-scrollbar-thumb { background:#2a2f4e; border-radius:99px; }
  .l-layout-sidebar::-webkit-scrollbar-track { background:#0f1123; }
  .l-layout-body    { flex:1; display:flex; flex-direction:column; height:100vh; overflow:hidden; min-width:0; }
  .l-layout-header  { flex-shrink:0; }
  .l-layout-main    { flex:1; overflow-y:auto; overflow-x:hidden; padding:24px; scrollbar-width:thin; scrollbar-color:#dde1ef transparent; }
  .l-layout-main::-webkit-scrollbar { width:5px; }
  .l-layout-main::-webkit-scrollbar-thumb { background:#dde1ef; border-radius:99px; }

  .l-sidebar-backdrop { display:none; position:fixed; inset:0; background:rgba(0,0,0,.5); z-index:199; }

  @media (max-width:768px) {
    .l-layout-main { padding:16px; }
    .l-layout-sidebar {
      position:fixed; left:0; top:0; bottom:0; z-index:200;
      transform:translateX(-100%);
    }
    .l-layout-sidebar.open {
      transform:translateX(0);
      box-shadow:4px 0 24px rgba(0,0,0,.3);
    }
    .l-sidebar-backdrop.open { display:block; }
  }
`;

const LibrarianLayout = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  return (
    <>
      <style>{style}</style>
      <div className="l-layout-root">
        <div className={`l-sidebar-backdrop ${sidebarOpen?'open':''}`} onClick={()=>setSidebarOpen(false)} />
        <div className={`l-layout-sidebar ${sidebarOpen?'open':''}`}>
          <LibrarianSidebar onClose={()=>setSidebarOpen(false)} />
        </div>
        <div className="l-layout-body">
          <div className="l-layout-header">
            <LibrarianHeader onMenuClick={()=>setSidebarOpen(o=>!o)} />
          </div>
          <main className="l-layout-main"><Outlet /></main>
        </div>
      </div>
    </>
  );
};

export default LibrarianLayout;
